import {z} from '@hono/zod-openapi';

import {identifiers} from './identifiers';

export const InventoryTurnoverQuerySchema = z
  .object({
    asOf: z.string().date().optional().openapi({example: '2026-09-30'}),
    warehouse: identifiers,
    branch: identifiers,
  })
  .openapi('InventoryTurnoverQuery');

export type InventoryTurnoverQuery = z.infer<typeof InventoryTurnoverQuerySchema>;
